import * as React from 'react'
import {LinkButton} from '@components/common/base/buttons'
import {Color} from '@components/common/base/buttons/types'

interface Props {
  children: string
  onMouseDown?: () => void
  color: Color
  className?: string
}

// onMouseDown need to prevent input onBlur
export const LinkSmall = (props: Props) => {
  const {children, color, className} = props

  const onMouseDown = (e: React.MouseEvent) => {
    e.preventDefault()
    props.onMouseDown?.()
  }

  return (
    <LinkButton
      color={color}
      onMouseDown={onMouseDown}
      noPaddings
      size="small"
      style={{fontSize: '12px'}}
      className={className}
    >
      {children}
    </LinkButton>
  )
}
